export default __webpack_public_path__ + "static/media/google-play.a71a80c5.svg";